import { useMemo } from 'react';
import { mapToItemToReturn } from '../utils/eligibility-utils';
import { ItemToReturn, OrderDetailsSessionDataV2 } from '../models/returns';
import { IReturnEligibilityResponse } from '../models/api';

const useInitialEligibleItems = (
  orderDetailsV2: OrderDetailsSessionDataV2 | undefined,
  returnEligibilityDetails: IReturnEligibilityResponse | undefined,
) => {
  const lineItemsToReturn: ItemToReturn[] = useMemo(() => {
    if (!orderDetailsV2) return [];
    const itemList = mapToItemToReturn(
      orderDetailsV2.lineItems,
      returnEligibilityDetails,
    );

    return itemList.filter((item) => {
      if (item.relationType && item.relationType === 'COMBO') return false;
      return item.isStatusDeliveredOrOrderPickedup;
    });
  }, [returnEligibilityDetails, orderDetailsV2]);

  const { eligibleItems, ineligibleItems } = useMemo(() => {
    return lineItemsToReturn.reduce(
      (acc, item) => {
        if (item.currentQuantity <= 0) {
          return acc;
        }

        const isReturnEligible = item?.eligibilities?.anyEligibility;
        if (isReturnEligible) {
          acc.eligibleItems.push(item);
        } else {
          acc.ineligibleItems.push(item);
        }

        return acc;
      },
      {
        eligibleItems: [] as ItemToReturn[],
        ineligibleItems: [] as ItemToReturn[],
      },
    );
  }, [lineItemsToReturn]);

  return { eligibleItems, ineligibleItems };
};

export default useInitialEligibleItems;
